export interface ThemeProps {
  theme: {
    colors: {
      primary: string,
      accent: string,
      background: string,
      secondaryFont: string,
      border: string,
      placeholder: string,
      backgroundGreen: string,
      textGreen: string,
      backgroundOrange: string,
      textOrange: string,
      backgroundRed: string,
      textRed: string,
      yellow: string
    },
    fontSizes: {
      small: string,
      medium: string,
      large: string,
      xLarge: string
    }
    breakpoints: number[],
    space: string[],
    containerWidth: string,
    borderRadius: string;
  }
}

const baseTheme = {
  colors: {
    primary: "#111",
    accent: "#34338a",
    accentLight: "#D8D7FE",
    background: "#f4f4f4",
    secondaryFont: "#7D879C", //same color as in variables.ts
    link: "#34338a",
    border: "#dddddd",
    placeholder: "#888888",
    backgroundGreen: "#E7FDD8",
    textGreen: "#66BF3C",
    backgroundOrange: "#FDEFC0",
    textOrange: "#b78c00",
    backgroundRed: "#FFB9A8",
    textRed: "#FF3100",
    textBlue: "#3721ff",
    backgroundBlue: "#a8acff",
    darkBlue: "rgb(0, 87, 255)",
    yellow: "#ffd700",
    lightGrey: "#F1F1F1",
    darkGrey: "#e1e1e1",
    darkestGrey: "#d5d5d5",
    white: "#fff",
    lightBlack: "#3f3f3f",
    internal: "#664a00",
    backgroundColumbiaBlue: "#B9D9EB",
    textCrayolaBlue: "#1F75FE"
  },

  fontSizes: {
    xSmall: "12px",
    small: "14px",
    medium: "16px",
    large: "18px",
    xLarge: "24px"
  },

  breakpoints: ["599px", "768px", "998px", "1200px", "1400px"],

  space: ["4px", "8px", "16px", "32px", "64px", "128px", "256px", "512px"],

  containerWidth: "1400px",

  borderRadius: "4px;"
};

export default baseTheme;
